import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useEffect, useState } from 'react';
import {collection, getDocs, getFirestore, onSnapshot, orderBy, query, Timestamp, where} from "firebase/firestore";
import CustomTooltip from './components/components';
import dayjs from 'dayjs';
import UsersOverTime from './components/usersOverTime';
import RequestsOverTime from './components/requestsOverTime';
import CelebritiesOverTime from './components/CelebritiesOverTime';
import CompletedRequestsOverTime from './components/CompletedRequestsOverTime';
import TopPeople from './components/topPeople/topPeople';
import RefundsOverTime from './components/refundsOverTime';
import EarningsOverTime from './components/earningsOverTime';
import BottomCelebs from './components/bottomPeople/bottomCelebs';
import BottomPeople from './components/bottomPeople/bottomPeople';
import RequestsDistribution from './components/requestsDistribution';

export default function Reports() {
    

    return (
        <div className='p-4 h-full w-full flex flex-col gap-10 '>
            <UsersOverTime/>
            <CelebritiesOverTime/>
            <RequestsOverTime/>
            <CompletedRequestsOverTime/>
            <RefundsOverTime/>
            <EarningsOverTime/>
            <TopPeople/>
            <BottomPeople/>
            <RequestsDistribution/>
            <div className='h-24 w-full'><div className='h-96'/></div>
        </div>
    )
}